if (window.location.href.indexOf("/products/") != -1) {
  function reload_js(src) {
    $('script[src="' + src + '"]').remove();
    $("<script>").attr("src", src).appendTo("head");
  }

  const $picker1 = $("#product-picker-1");
  const handle = $picker1.attr("data-handle");

  initComplimentoryProducts(handle);

  function initComplimentoryProducts(handlen) {
    let selectedVariants = {
      product1: null,
      product2: null,
    };

    fetch(`/products/${handlen}.js`)
      .then((res) => res.json())
      .then((product) => {
        const $picker1 = $("#product-picker-1");

        const metafields = JSON.parse(
          document.getElementById("variantMetafields").textContent
        );

        const variantsHtml = product.variants
          .map((variant) => {
            const meta = metafields[variant.id];
            const sprayCount = parseFloat(meta?.spray_count || 0);
            const isUnavailable = variant.available
              ? ""
              : 'data-unavailable="true"';

            return `
          <div class="variant-swatch-item custom-choose-variants-wrapper ${
            variant.available ? "" : "disabled"
          }"
               data-id="${variant.id}" data-product="product1" ${isUnavailable}
               data-image="${
                 variant.featured_image?.src || product.featured_image
               }"
               data-title="${variant.title}"
               data-product-title="${product.title}">
            <div class="variant-title">${variant.title}</div>
            <div class="spray-count">
              ${sprayCount ? `${sprayCount} Sprühstosse` : ""}
            </div>
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" class="svg" style="display:none;">
              <rect width="32" height="32" fill="#00E8C1" fill-opacity="0.2"/>
              <rect width="32" height="32" fill="url(#paint0_linear_1_1676)" fill-opacity="0.2"/>
              <rect x="0.5" y="0.5" width="31" height="31" stroke="#00E8C1" stroke-opacity="0.2"/>
              <path d="M16.5506 19.3483V18.6989C16.5506 18.2219 16.6551 17.7829 16.8652 17.3821C17.0792 16.9812 17.3896 16.6585 17.7965 16.414C18.2035 16.1694 18.6964 16.0472 19.2753 16.0472C19.871 16.0472 20.3702 16.1694 20.7729 16.414C21.1757 16.6545 21.4798 16.9752 21.6854 17.376C21.8951 17.7769 22 18.2179 22 18.6989V19.3483C22 19.8253 21.8951 20.2643 21.6854 20.6651C21.4756 21.066 21.1673 21.3887 20.7604 21.6332C20.3576 21.8777 19.8626 22 19.2753 22C18.688 22 18.1909 21.8777 17.784 21.6332C17.377 21.3887 17.0687 21.066 16.8589 20.6651C16.6534 20.2643 16.5506 19.8253 16.5506 19.3483ZM18.193 18.6989V19.3483C18.193 19.665 18.2727 19.9556 18.4321 20.2202C18.5915 20.4847 18.8726 20.617 19.2753 20.617C19.6822 20.617 19.9612 20.4867 20.1122 20.2262C20.2674 19.9616 20.345 19.669 20.345 19.3483V18.6989C20.345 18.3782 20.2716 18.0856 20.1248 17.821C19.978 17.5524 19.6948 17.4181 19.2753 17.4181C18.881 17.4181 18.602 17.5524 18.4384 17.821C18.2748 18.0856 18.193 18.3782 18.193 18.6989ZM10 12.3011V11.6517C10 11.1707 10.107 10.7297 10.3209 10.3289C10.5349 9.928 10.8453 9.60731 11.2522 9.36679C11.6592 9.12226 12.1521 9 12.731 9C13.3225 9 13.8196 9.12226 14.2223 9.36679C14.6293 9.60731 14.9355 9.928 15.1411 10.3289C15.3466 10.7297 15.4494 11.1707 15.4494 11.6517V12.3011C15.4494 12.7821 15.3445 13.2231 15.1348 13.624C14.9292 14.0208 14.623 14.3395 14.216 14.58C13.8091 14.8205 13.3141 14.9408 12.731 14.9408C12.1395 14.9408 11.6403 14.8205 11.2334 14.58C10.8306 14.3395 10.5244 14.0188 10.3146 13.6179C10.1049 13.2171 10 12.7781 10 12.3011ZM11.655 11.6517V12.3011C11.655 12.6218 11.7326 12.9144 11.8878 13.179C12.0472 13.4396 12.3283 13.5698 12.731 13.5698C13.1337 13.5698 13.4106 13.4396 13.5616 13.179C13.7168 12.9144 13.7944 12.6218 13.7944 12.3011V11.6517C13.7944 11.331 13.721 11.0384 13.5742 10.7738C13.4274 10.5052 13.1463 10.371 12.731 10.371C12.3325 10.371 12.0535 10.5052 11.8941 10.7738C11.7347 11.0424 11.655 11.335 11.655 11.6517ZM10.7174 21.6573L19.5773 9.34274H21.1505L12.2905 21.6573H10.7174Z" fill="#00E8C1"/>
              <defs>
                <linearGradient id="paint0_linear_1_1676" x1="16" y1="0" x2="16" y2="32" gradientUnits="userSpaceOnUse">
                  <stop stop-color="#527D76"/>
                  <stop offset="1" stop-color="#0F1716"/>
                </linearGradient>
              </defs>
            </svg>
          </div>
        `;
          })
          .join("");

        const allUnavailable = product.variants.every((v) => !v.available);
        const $submitBtn = $(".product__info-wrapper .product-form__submit");

        console.log("availability" + allUnavailable);

        if (allUnavailable) {
          $submitBtn.prop("disabled", true).addClass("disabled");
        } else {
          if (!product.variants[0].available) {
            $submitBtn.prop("disabled", true).addClass("disabled");
          } else {
            $submitBtn.prop("disabled", false).removeClass("disabled");
          }
        }

        $picker1.find(".variant-options").html(variantsHtml);

        if (
          product.variants.length > 0 &&
          product.variants[0].title.indexOf("Default") == -1
        ) {
          $picker1.find(".variant-options").show();
          $(".custom-products-label-updated").show();
        } else {
          $picker1.find(".variant-options").hide();
          $(".custom-products-label-updated").hide();
        }

        let $activeVariant;

        if ($("#selling_products").is(":checked")) {
          const $fiftyMlVariant = $picker1
            .find(".variant-swatch-item")
            .filter(function () {
              return $(this)
                .data("title")
                .toLowerCase()
                .includes("50ml");
            })
            .first();

          if ($fiftyMlVariant.length) {
            $picker1.find(".variant-swatch-item").each(function () {
              const $el = $(this);
              const is50ml = this === $fiftyMlVariant[0];

              $el.removeClass("active");

              if (!is50ml && !$el.data("unavailable")) {
                $el.addClass("disabled");
              } else {
                $el.removeClass("disabled").addClass("active");
              }
            });

            $activeVariant = $fiftyMlVariant;
          }
        } else {
          const $firstVariant = $picker1
            .find(".variant-swatch-item")
            .not(".disabled")
            .first();

          $firstVariant.addClass("active");
          $activeVariant = $firstVariant;
        }

        if ($activeVariant && $activeVariant.length) {
          const variantId = $activeVariant.data("id");

          selectedVariants.product1 = variantId;

          $picker1
            .find(".selected-products-wrapper")
            .attr("data-product-id", variantId);

          updateProduct3Mirror($activeVariant);
          setTimeout(updateSellingPriceAndCompare, 10);

          const metafields = JSON.parse(
            document.getElementById("variantMetafields").textContent || "{}"
          );

          const meta = metafields[variantId];
          const sprayCount = parseFloat(meta?.spray_count || 0);
          const priceCents = parseFloat(meta?.price || 0);
          const price = priceCents / 100;
          const shopCurrency = window.Shopify?.currency?.active || "₹";

          const perSprayText =
            sprayCount && priceCents
              ? `<b style="color:#DBE6E4;">${shopCurrency} ${(price / sprayCount).toFixed(2)}</b> / Sprühstoss`
              : "";

          $picker1.find(".custom-products-label-updated").html(
            `Grössen: <span class="per-spray-label per_spray_price">${perSprayText}</span>`
          );
        }
      });

    function updateProduct3Mirror($variantEl) {
      const image = $variantEl.data("image");
      const title = $variantEl.data("product-title");
      const id = $variantEl.data("id");
      const $picker3 = $("#product3-placeholder");

      $picker3
        .find(".custom-choose-product")
        .attr("data-variantid", id);

      $picker3
        .find(".selected-image")
        .html(`<img src="${image}" alt="${title}" />`);

      $picker3.find(".selected-label").text(title);

      $picker3
        .find(".selected-products-wrapper")
        .attr("data-product-id", id);
    }

    $(".selected-products-wrapper").on("click", function (e) {
      e.stopPropagation();

      const $list = $(this).siblings(".list-products-wrapper");
      const isOpen = $(this).hasClass("active");

      $(".list-products-wrapper").slideUp(150);
      $(".selected-products-wrapper").removeClass("active");

      if (!isOpen) {
        $(this).addClass("active");
        $list.slideDown(150);
      }
    });

    $(document).on("click", ".variant-swatch-item.disabled", function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
    });

    $("#selling_products").on("change", function () {
      const $checkbox = $(this);
      const $picker1 = $("#product-picker-1");
      const $variants = $picker1.find(".variant-swatch-item");

      console.log($(this).is(":checked"));

      $(".checkbox-error").remove();

      if (this.checked) {
        const $fiftyMlVariant = $variants
          .filter(function () {
            const title = ($(this).data("title") || "").toLowerCase();
            return (
              title.includes("50ml") &&
              !$(this).data("unavailable")
            );
          })
          .first();

        if ($fiftyMlVariant.length) {
          $(".custom-complementary-products").addClass("opened");

          $variants.each(function () {
            const $el = $(this);
            const is50ml = this === $fiftyMlVariant[0];

            $el.removeClass("active");

            if (!is50ml && !$el.data("unavailable")) {
              $el.addClass("disabled");
            } else if (is50ml) {
              $el.removeClass("disabled").addClass("active");
            }
          });

          $(".product-form__submit")
            .prop("disabled", false)
            .removeClass("disabled");

          const variantId = $fiftyMlVariant.data("id");
          selectedVariants.product1 = variantId;

          updateProduct3Mirror($fiftyMlVariant);
          updateSellingPriceAndCompare();

          const metafields = JSON.parse(
            document.getElementById("variantMetafields").textContent || "{}"
          );

          const meta = metafields[variantId];
          const sprayCount = parseFloat(meta?.spray_count || 0);
          const priceCents = parseFloat(meta?.price || 0);
          const price = priceCents / 100;
          const shopCurrency =
            window.Shopify?.currency?.active || "₹";

          const perSprayText =
            sprayCount && priceCents
              ? `<b style="color:#DBE6E4;">${shopCurrency} ${(price / sprayCount).toFixed(2)}</b> / Sprühstoss`
              : "";

          $picker1.find(".custom-products-label-updated").html(
            `Grössen: <span class="per-spray-label per_spray_price">${perSprayText}</span>`
          );
        } else {
          $checkbox.prop("checked", false);
          $(".custom-complementary-products").removeClass("opened");

          $checkbox
            .closest("label, .checkbox-wrapper")
            .after(
              `<div class="checkbox-error" style="color: red; font-size: 14px; margin-top: 5px;">
                50ml variant is not available for this product.
              </div>`
            );
        }
      } else {
        $(".custom-complementary-products").removeClass("opened");

        $variants.each(function () {
          if (!$(this).data("unavailable")) {
            $(this).removeClass("disabled");
          }
        });

        updateSellingPriceAndCompare();
      }
    });

    $(document).on("click", function () {
      $(".list-products-wrapper").slideUp(150);
      $(".selected-products-wrapper").removeClass("active");
      $(".custom-complementary-products").removeClass("error");
    });

    $(".option-products-wrapper").on("click", function () {
      $(".custom-complementary-products").removeClass("error");

      const handle = $(this).data("handle");
      const $picker = $(this).closest(".product-block");
      const pickerId = $picker.attr("id");

      const productKey =
        pickerId === "product-picker-1"
          ? "product1"
          : "product2";

      const imageUrl = $(this).find("img").attr("src");
      const label = $(this).find(".option-label").text();

      $picker.find(".selected-label").text(label);

      if ($picker.find(".selected-image").length === 0) {
        $picker
          .find(".selected-products-wrapper")
          .prepend(
            `<div class="selected-image"><img src="${imageUrl}" alt="${label}" /></div>`
          );
      } else {
        $picker
          .find(".selected-image")
          .html(`<img src="${imageUrl}" alt="${label}" />`);
      }

      $picker.find(".list-products-wrapper").slideUp(150);
      $picker.find(".selected-products-wrapper").removeClass("active");

      if (productKey === "product2") {
        console.log("tesssst");

        selectedVariants.product2 = $(this).attr("data-variantid");

        updateSellingPriceAndCompare();

        $picker.attr(
          "data-product-id",
          $(this).attr("data-variantid")
        );

        $picker.attr(
          "data-handle",
          $(this).attr("data-handle")
        );

        $picker.find(".variant-options").html("");

        return;
      }

      console.log(handle);

      $.ajax({
        url: `/products/${handle}`,
        method: "GET",
        success: function (data) {
          $(".main-product-parent-wrapper").html(
            $(data)
              .find(".main-product-parent-wrapper")
              .html()
          );

          initComplimentoryProducts(handle);

          $("script").each(function () {
            var src = $(this).attr("src");

            if (src) {
              if (
                src.indexOf("global.js") != -1 ||
                src.indexOf("product-form.js") != -1
              ) {
                reload_js(src);
              }
            }
          });
        },
      });
    });

    $("#product3-placeholder")
      .find(".option-products-wrapper")
      .click(function () {
        var handle = $(this).attr("data-handle");

        $.ajax({
          url: `/products/${handle}`,
          method: "GET",
          success: function (data) {
            $(".main-product-parent-wrapper").html(
              $(data)
                .find(".main-product-parent-wrapper")
                .html()
            );

            initComplimentoryProducts(handle);

            $("script").each(function () {
              var src = $(this).attr("src");

              if (src) {
                if (
                  src.indexOf("global.js") != -1 ||
                  src.indexOf("product-form.js") != -1
                ) {
                  reload_js(src);
                }
              }
            });

            $(".custom-complementary-products").addClass("opened");
            $("#selling_products").prop("checked", true);
          },
        });
      });

    $(document).on("click", ".variant-swatch-item", function () {
      const $this = $(this);
      const isUnavailable = $this.data("unavailable");
      const $submitBtn = $(".product__info-wrapper .product-form__submit");

      if (isUnavailable) {
        $submitBtn.prop("disabled", true).addClass("disabled");
        return;
      } else {
        $submitBtn.prop("disabled", false).removeClass("disabled");
      }

      const variantId = $this.data("id");

      $this
        .closest(".variant-options")
        .find(".variant-swatch-item")
        .removeClass("active");

      $this.addClass("active");

      selectedVariants.product1 = variantId;

      updateProduct3Mirror($this);
      updateSellingPriceAndCompare();

      const metafields = JSON.parse(
        document.getElementById("variantMetafields").textContent
      );

      const meta = metafields[variantId];
      const sprayCount = parseFloat(meta?.spray_count || 0);
      const priceCents = parseFloat(meta?.price || 0);
      const price = priceCents / 100;
      const shopCurrency =
        window.Shopify?.currency?.active || "₹";

      const perSprayText =
        sprayCount && priceCents
          ? `<b style="color:#DBE6E4;">${shopCurrency} ${(price / sprayCount).toFixed(2)}</b> / Sprühstoss`
          : "";

      const $picker = $this.closest(".product-block");

      $picker
        .find(".custom-products-label-updated")
        .html(
          `Grössen: <span class="per-spray-label per_spray_price">${perSprayText}</span>`
        );
    });

    function updateProduct3Mirror($variantEl) {
      const image = $variantEl.data("image");
      const title = $variantEl.data("product-title");
      const id = $variantEl.data("id");

      const $picker3 = $("#product3-placeholder");

      $picker3
        .find(".selected-image")
        .html(`<img src="${image}" alt="${title}" />`);

      $picker3.find(".selected-label").text(title);

      $picker3
        .find(".selected-products-wrapper")
        .attr("data-product-id", id);
    }

    function updateSellingPriceAndCompare() {
      const metafields = JSON.parse(
        document.getElementById("variantMetafields").textContent || "{}"
      );

      const currency =
        window.Shopify?.currency?.active || "₹";

      const variantId1 = selectedVariants.product1;
      const variantId2 = selectedVariants.product2;

      let price1 = 0;
      let price2 = 0;
      let compare1 = 0;
      let compare2 = 0;

      if (variantId1 && metafields[variantId1]) {
        price1 = parseFloat(
          metafields[variantId1].price || 0
        );

        compare1 = parseFloat(
          metafields[variantId1].compare_at_price || 0
        );
      }

      const isChecked =
        document.getElementById("selling_products")?.checked;

      if (isChecked && variantId2 && metafields[variantId2]) {
        price2 = parseFloat(
          metafields[variantId2].price || 0
        );

        compare2 = parseFloat(
          metafields[variantId2].compare_at_price || 0
        );
      }

      const totalPrice = price1 + price2;
      const totalCompare =
        (compare1 || 0) + (compare2 || 0);

      const formattedPrice =
        `${currency} ${(totalPrice / 100).toFixed(2)}`;

      $(".main-price").text(" - " + formattedPrice);

      const formattedPrice1 =
        `${currency} ${(price1 / 100).toFixed(2)}`;

      $(".price_change").text(formattedPrice1);

      const formattedCompPrice1 =
        `${currency} ${(compare1 / 100).toFixed(2)}`;

      console.log(
        formattedCompPrice1 +
          "akjdbkhdb" +
          formattedPrice1
      );

      if (compare1 > 0) {
        $(".compare_price_change")
          .text(formattedCompPrice1)
          .show();

        $(".price__badge-sale").show();
      } else {
        $(".compare_price_change").hide();
        $(".price__badge-sale").hide();
      }
    }
  }

  function syncFormDisabledClass() {
    const submitBtn =
      document.querySelector(".product__info-wrapper .product-form__submit");

    if (!submitBtn) return;

    const form = submitBtn.closest("form");

    if (!form) return;

    const updateFormClass = () => {
      if (
        submitBtn.disabled ||
        submitBtn.classList.contains("disabled")
      ) {
        form.classList.add("disabled");
      } else {
        form.classList.remove("disabled");
      }
    };

    updateFormClass();

    const observer = new MutationObserver(updateFormClass);

    observer.observe(submitBtn, {
      attributes: true,
      attributeFilter: ["disabled", "class"],
    });

    const container =
      document.querySelector(".product-block") ||
      document.body;

    const outerObserver = new MutationObserver(() => {
      const newBtn =
        document.querySelector(".product__info-wrapper .product-form__submit");

      if (newBtn && newBtn !== submitBtn) {
        observer.disconnect();
        syncFormDisabledClass();
      }
    });

    outerObserver.observe(container, {
      childList: true,
      subtree: true,
    });
  }

  document.addEventListener(
    "DOMContentLoaded",
    syncFormDisabledClass
  );

  window.addEventListener("pageshow", function (event) {
    if (
      event.persisted ||
      performance.getEntriesByType("navigation")[0]?.type ===
        "back_forward"
    ) {
      $("#selling_products").prop("checked", false);
      $(".custom-complementary-products").removeClass("opened");
      updateSellingPriceAndCompare();
    }
  });
}

function updateSwiperParentState() {
  document.querySelectorAll(".btn-container").forEach((parent) => {
    const hasDisabledChild = parent.querySelector(
      ".swiper-button-disabled"
    );

    parent.classList.toggle(
      "disabled",
      !!hasDisabledChild
    );
  });
}

function waitForSwiperButtons(callback, timeout = 3000) {
  const start = Date.now();

  const interval = setInterval(() => {
    const found = document.querySelector(
      ".swiper-button-disabled"
    );

    if (
      found ||
      Date.now() - start > timeout
    ) {
      clearInterval(interval);
      callback();
    }
  }, 200);
}

document.addEventListener("DOMContentLoaded", () => {
  waitForSwiperButtons(() => {
    updateSwiperParentState();
  });
});

document.addEventListener("click", () => {
  setTimeout(updateSwiperParentState, 100);
});

document.addEventListener(
  "shopify:section:load",
  () => {
    setTimeout(updateSwiperParentState, 200);
  }
);

document.addEventListener(
  "shopify:section:select",
  () => {
    setTimeout(updateSwiperParentState, 200);
  }
);

$(".selling-label-combo").click(function () {
  $('label[for="selling_products"]').click();
});